import CustomTable from 'components/CustomTable';
import {Box, Button} from '@chakra-ui/react';
import StyledChip from 'components/StyledChip';
import {StyledTableButton} from 'components/StyledBtn';
import ClientDetailCell from 'components/TableCell/ClientDetailCell';
import StatusTableCell from 'components/TableCell/StatusTableCell';
import {get} from 'lodash';
import {useTranslation} from 'react-i18next';
import {currencyFormatorWithDecimal, formatDateTimes} from 'utils/formator';
import {useState} from 'react';
import RequestDetailDialog from 'components/Dialog/RequestDetailDialog';
import ClosedOrderDetails from 'page/app/Account/ClosedOrderDetails';

import {formatDate} from 'utils/formator';
import numeral from 'numeral';
import {StyledButton} from 'components/StyledBtn';

export default ({
    data,
    totalPage,
    page,
    setPage,
    totalItems,
    pageSize,
    pageIndex,
    isLoading,
    userId,
    setIsDetail = () => {},
    detail,
    setDetail,
}) => {
    const [showDetail, setShowDetail] = useState(false);
    const {t} = useTranslation('app');
    const onRowClick = (rowData) => {
        setIsDetail(true);
        setDetail(rowData);
    };
    const column = [
        {
            label: t('date'),
            dataKey: 'date',
            columProps: {
                align: 'left',
                flexGrow: 1,
                minWidth: 140,
            },
            renderCell: (rawData) => {
                return formatDate(get(rawData, 'date'));
            },
        },
        {
            label: t('source'),
            dataKey: 'origin',
            columProps: {
                align: 'left',
                flexGrow: 1,
                minWidth: 140,
            },
        },
        {
            label: t('currency'),
            dataKey: 'currency',
            columProps: {
                align: 'left',
                minWidth: 140,
                flexGrow: 1,
            },
        },
        {
            label: t('closedLots'),
            dataKey: 'volume',
            columProps: {
                align: 'right',
                minWidth: 140,
                flexGrow: 1,
            },
            renderCell: (rowData) => {
                return numeral(get(rowData, 'volume')).format('0,0.00');
            },
        },
        {
            label: t(''),
            dataKey: 'action',
            columProps: {
                align: 'center',
                minWidth: 140,
                flexGrow: 1,
            },
            renderCell: (rowData) => {
                return (
                    <StyledButton
                        onClick={() => onRowClick(rowData)}
                        variant="primary"
                        fontWeight={400}
                        fontSize={10}
                        size="xs"
                        h={'20px'}
                    >
                        {t('viewMore')}
                    </StyledButton>
                );
            },
        },
    ];
    return (
        <Box overflow={'auto'} h="100%" pb={6}>
            <CustomTable
                column={column}
                {...{
                    data,
                    totalPage,
                    page,
                    setPage,
                    totalItems,
                    pageSize,
                    loading: isLoading,
                    pageIndex,
                }}
                // onRowClick={onRowClick}
            />
            <ClosedOrderDetails
                account={detail}
                isOpen={showDetail}
                onClose={() => setShowDetail(false)}
                userId={userId}
            />
        </Box>
    );
};
